export default {"src":"/_next/static/media/bluedot-logo-c.5c7bd623.svg","height":36,"width":229};